/** A task parsed from one pasted checklist line. */
export interface ParsedTaskLine {
  name: string;
  assigneeEmail: string | null;
}

const LIST_PREFIX_REGEX = /^(?:[-*•]\s*(?:\[[ xX]?\]\s*)?|\d+[.)]\s*)/;
const TRAILING_EMAIL_REGEX = /\s+@?([\w.+-]+@[\w-]+(?:\.[\w-]+)+)\s*$/;

/**
 * Parses pasted multi-line text into tasks: strips markdown checklist and
 * list prefixes (`- [ ]`, `-`, `*`, `1.`) and pulls a trailing `@email` off
 * each line as the assignee.
 */
export function parseTaskPasteLines(text: string): ParsedTaskLine[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((line) => {
      const withoutPrefix = line.replace(LIST_PREFIX_REGEX, "").trim();
      const emailMatch = withoutPrefix.match(TRAILING_EMAIL_REGEX);
      if (!emailMatch) {
        return { name: withoutPrefix, assigneeEmail: null };
      }
      return {
        name: withoutPrefix.slice(0, emailMatch.index).trim(),
        assigneeEmail: emailMatch[1].toLowerCase(),
      };
    })
    .filter((parsed) => parsed.name.length > 0);
}
